<template>
  <el-dialog
    title="添加"
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="handleClose"
  >
    <el-form label-width="80px" ref="searchForm">
      <!-- 商品 -->
      <div v-if="currentInfo.type == '2'">
        <el-row :gutter="22">
          <el-col :span="8">
            <el-form-item label="所属分类" label-width="80px" prop="pid">
              <el-cascader
                v-model="searchForm.subjectIds"
                :show-all-levels="false"
                ref="tree"
                collapse-tags
                :options="subjectTreeList"
                :props="subjectTreeProps"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品名称">
              <el-input v-model="searchForm.name" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="getList()">查询</el-button>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table
              :data="tableList"
              tooltip-effect="dark"
              style="width: 100%"
              highlight-current-row
              @selection-change="selectionChange"
              border
              ref="multipleTable"
              v-loading="loading1"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="name" show-overflow-tooltip label="商品">
                <template slot-scope="row">
                  <el-row>
                    <el-col :span="8">
                      <span>
                        <img
                          style="margin-right: 10px"
                          width="100%"
                          height="44px"
                          :src="
                            row.row.logo
                              ? row.row.logo
                              : '../../../static/image/noImg.png'
                          "
                        />
                      </span>
                    </el-col>
                    <el-col :span="16">
                      <span
                        style="color: rgb(77, 148, 255); margin-left: 10px"
                        >{{ row.row.name }}</span
                      >
                      <span style="display: block; margin-left: 10px">
                        <span style="color: red">￥{{ row.row.price }}</span>
                        <span
                          style="
                            text-decoration: line-through;
                            color: rgb(162, 170, 188);
                          "
                          >￥{{ row.row.originalPrice }}</span
                        >
                      </span>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="120"
                prop="agentPrice"
                label="售价"
              >
                <template slot-scope="row">
                  <span style="display: block">
                    <span style="color: red">￥{{ row.row.price }}</span>
                    <span
                      style="
                        text-decoration: line-through;
                        color: rgb(162, 170, 188);
                      "
                      >￥{{ row.row.originalPrice }}</span
                    >
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="validDay"
                width="100"
                label="有效期"
              >
                <template slot-scope="row">{{
                  row.row.validDay ? row.row.validDay + "天" : "不限"
                }}</template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="type"
                label="类型"
                width="80"
              ></el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next"
              style="margin-top: 20px; text-align: right"
              :total="page.total"
              :page-size="page.pageSize"
              :current-page="page.pageNumber"
              @size-change="sizeChange"
              @current-change="currentChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
      <!-- 政策 -->
      <div v-else-if="currentInfo.type == '3'">
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table
              :data="tableList"
              tooltip-effect="dark"
              style="width: 100%"
              highlight-current-row
              @selection-change="selectionChange"
              ref="multipleTable"
              border
              v-loading="loading1"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="poster" label="图片" width="120">
                <template slot-scope="row">
                  <img
                    style="margin-right: 10px"
                    width="100%"
                    height="44px"
                    :src="
                      row.row.poster
                        ? row.row.poster
                        : '../../../static/image/noImg.png'
                    "
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="city"
                label="城市"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="title"
                label="标题"
                width="250"
              ></el-table-column>
              <el-table-column
                prop="content"
                label="内容"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next"
              style="margin-top: 20px; text-align: right"
              :total="page.total"
              :page-size="page.pageSize"
              :current-page="page.pageNumber"
              @size-change="sizeChange"
              @current-change="currentChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
      <!-- 资讯 -->
      <div v-else-if="currentInfo.type == '4'">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="类型">
              <el-select
                v-model="searchForm.type"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="名称">
              <el-input v-model="searchForm.name" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="getList()">查询</el-button>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table
              :data="tableList"
              tooltip-effect="dark"
              style="width: 100%"
              highlight-current-row
              @selection-change="selectionChange"
              ref="multipleTable"
              border
              v-loading="loading1"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="type" label="类型" width="80">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.type == 5" effect="dark">新闻</el-tag>
                  <el-tag v-else type="success">动态</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="标题"></el-table-column>
              <el-table-column prop="poster" label="图片" width="120">
                <template slot-scope="row">
                  <img
                    style="margin-right: 10px"
                    width="100%"
                    height="44px"
                    :src="
                      row.row.poster
                        ? row.row.poster
                        : '../../../static/image/noImg.png'
                    "
                  />
                </template>
              </el-table-column>
              <el-table-column
                label="内容"
                show-overflow-tooltip
                prop="content"
              >
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next"
              style="margin-top: 20px; text-align: right"
              :total="page.total"
              :page-size="page.pageSize"
              :current-page="page.pageNumber"
              @size-change="sizeChange"
              @current-change="currentChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
      <!-- 老师 -->
      <div v-else-if="currentInfo.type == '5'">
        <el-row :gutter="22">
          <el-col :span="8">
            <el-form-item label="老师姓名">
              <el-input v-model="searchForm.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="getList()">查询</el-button>
          </el-col>
        </el-row>
        <el-table
          :data="tableList"
          tooltip-effect="dark"
          style="width: 100%"
          highlight-current-row
          @selection-change="selectionChange"
          ref="multipleTable"
          border
          v-loading="loading1"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(255, 255, 255, 0.8)"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="title" label="姓名"></el-table-column>
          <el-table-column label="内容" show-overflow-tooltip prop="content">
          </el-table-column>
          <el-table-column prop="summary" label="简介"></el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next"
          style="margin-top: 20px; text-align: right"
          :total="page.total"
          :page-size="page.pageSize"
          :current-page="page.pageNumber"
          @size-change="sizeChange"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align: right">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="closeDialog">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,
      searchForm: { subjectIds: [] },
      subjectTreeList: [],
      loading1: false,
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        expandTrigger: "hover",
        multiple: true,
      },
      tableList: [],
      page: { pageSize: 10, pageNumber: 1, total: 0 },
      selectList: [],
      typeOptions: [
        {
          value: "5",
          label: "公司新闻",
        },
        {
          value: "1",
          label: "行业动态",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "loginData",
      "addDialogVisible",
      "currentInfo",
      "addDialogSingle",
    ]),
  },
  watch: {
    addDialogVisible(val) {
      if (val) {
        this.page.pageNumber = 1;
        this.searchForm = { subjectIds: [] };
        this.getList();
      } else {
        this.tableList = [];
        this.page.total = 0;
      }
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      if (!val) {
        this.$store.commit("design/SET_ADDDIALOGVISIBLE", {
          addDialogVisible: false,
        });
      }
    },
  },
  methods: {
    closeDialog() {
      if (this.selectList.length != 0) {
        this.$emit("addPageItemList", this.selectList);
        this.dialogVisible = false;
      } else {
        this.$message.error("请至少选择一条数据");
      }
    },
    selectionChange(val) {
      if (this.addDialogSingle) {
        if (val.length == 2) {
          this.$refs.multipleTable.toggleRowSelection(val[0], false);
          this.selectList = [val[0]];
        } else if (val.length > 2) {
          this.$message.error("只能选择一条数据");
          this.$refs.multipleTable.clearSelection();
          this.selectList = [];
        } else {
          this.selectList = val;
        }
      } else {
        this.selectList = val;
      }
    },
    getList() {
      this.loading1 = true;
      let arr = [];
      let obj = Object.assign({}, this.page, this.searchForm);
      if (obj.subjectIds.length > 0) {
        obj.subjectIds.forEach((item) => {
          arr.push(item.reverse()[0]);
        });
      }
      obj.subjectIds = arr;
      let requestUrl = "pageList";
      if (this.currentInfo.type == "3") {
        requestUrl = "pageListPolicy";
      } else if (this.currentInfo.type == "4") {
        requestUrl = "pageListInformation";
      } else if (this.currentInfo.type == "5") {
        requestUrl = "pageListInformation";
        obj.type = "2";
        obj.active = 1;
      }

      this.api.goodsInfo[requestUrl](obj)
        .then((result) => {
          this.loading1 = false;
          this.tableList = result.data.records;
          this.page.total = result.data.total;
          this.arrsSelect = [];
        })

        .catch((error) => {
          console.log(error);
        });
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getList();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    getSubjectTreeList() {
      this.api.getSubjectTreeList().then((result) => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              delete items.children;
            }
          }
        }
        this.subjectTreeList = result.data;
      });
    },
  },
  mounted() {
    this.getSubjectTreeList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/designPage/components/addDialog.vue